import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiResponse, ApiService } from './api.service';

export interface GameNightData {
  options: {
    id: number;
    title: string;
    image_url: string;
    selected: boolean;
    vote_count: number;
  }[]
}

@Injectable({
  providedIn: 'root'
})
export class DataShareService {

  api: ApiService = inject(ApiService);

  constructor() {
    this.fetchGameNightData().subscribe({
      error: (error) => {
        // Error already logged in fetchGameNightData
      }
    });
  }

  gameNightData: BehaviorSubject<GameNightData|null> = new BehaviorSubject<GameNightData|null>(null);

  fetchGameNightData(): Observable<ApiResponse> {
    return new Observable(observer => {
      this.api.get("gamenight/getGamenightData.php").subscribe({
        next: (data: ApiResponse) => {
          if (data.code == 200) {
            this.gameNightData.next(data.data as GameNightData);
          }
          observer.next(data);
          observer.complete();
        },
        error: (error) => {
          console.error('Failed to fetch game night data:', error);
          // Keep existing data on error rather than clearing it
          observer.error(error);
        }
      });
    });
  }

}
